import React from 'react'
import DefaultForm from '../../../../../ui/forms/default-form'
import { hasAvailableAction } from '../../../../../ui/gov-actions'
import { SendDraftEnrolmentFields, SendDraftEnrolmentDone } from './fields'

const actionValue = 'submit_draft_enrolment'
const actionLabel = 'Submit Draft Enrolment'

const available = record => hasAvailableAction(record, actionValue)

const formEndPoint = ({ gov_id }) =>
  process.env.REACT_APP_API_HOST + `/api/ccs-enrolments/children/${gov_id}/submit-draft`

const actionForm = ({ record }) => ({ handleSuccess }) => (
  <DefaultForm
    url={formEndPoint(record)}
    value={actionValue}
    label={actionLabel}
    loadingTitle="Sending Draft Enrolment"
    formComponent={SendDraftEnrolmentFields}
    handleSuccess={payload =>
      handleSuccess(
        {
          [actionValue]: <SendDraftEnrolmentDone errors={payload.errors} />,
        },
        actionValue
      )
    }
  />
)

export const submitDraftEnrolment = ({ record, refresh_enrolments }) =>
  available(record)
    ? {
      label: actionLabel,
      value: actionValue,
      onComplete: refresh_enrolments,
      actionForm: actionForm({ record }),
    }
    : null



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/submit-draft-enrolment/index.js